// extracted by mini-css-extract-plugin
export default {"shopIcon":"ShopIcon_shopIcon__OiSEI"};